import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { AuthenticationService } from "src/app/services/authentication.service";
import { ParcelTrackerRoleEnum } from "src/app/shared/generated/enum/parcel-tracker-role-enum";

/**
 * Mirrors the legacy ParcelPrivilegedDataViewFeature (= GetRolesExceptUnassigned): admits any
 * authenticated Parcel Tracker user whose role is set and is not Unassigned. Used to keep
 * privileged-data pages (e.g. Parcels by Land Capability) hidden from Unassigned and public users.
 */
@Injectable({ providedIn: "root" })
export class ParcelTrackerPrivilegedViewAccessGuard implements CanActivate {
    constructor(private authenticationService: AuthenticationService, private router: Router) {}

    canActivate(): Observable<boolean> {
        return this.authenticationService.getCurrentUser().pipe(
            take(1),
            map((user) => {
                const role = user?.ParcelTrackerRoleID;
                const allowed = role != null && role !== ParcelTrackerRoleEnum.Unassigned;
                if (!allowed) {
                    this.router.navigate(["/moorings/inventory"]);
                    return false;
                }
                return true;
            }),
        );
    }
}
